
import React from 'react'
import usePending from '@apex/lib/hooks/usePending'
import TextInputField from './TextInputField'
import Button from './Button'
import Form from './Form'

/**
 * AccountSettingsForm is an account settings form.
 */

export default function AccountSettingsForm({ name, onSubmit }) {
  const [pending, submit] = usePending(onSubmit)
  return <Form onSubmit={submit}>
    <Form.Row>
      <TextInputField
        name="name"
        label="Full Name"
        placeholder="Mark Corrigan"
        defaultValue={name}
        required />
    </Form.Row>
    <Form.Actions>
      <Button theme="primary" pending={pending}>Update Settings</Button>
    </Form.Actions>
  </Form>
}
